import React, { useEffect, useState } from 'react';
import { Breadcrumb } from 'antd';
import { HomeOutlined } from '@ant-design/icons';
import { Link, useHistory } from 'react-router-dom';

export default () => {
  const history = useHistory();
  const [url, setUrl] = useState(history.location.pathname.split('/'));
  for (let i = 0; i < url.length; i++) {
    url[i] = url[i].replaceAll('-', ' ');
    url[i] = url[i].charAt(0).toUpperCase() + url[i].substring(1);
  }

  useEffect(() => {
    history.listen((location, action) => {
      setUrl(location.pathname.split('/'));
    });
  }, [history]);

  return (
    <div className="Breadcrumb">
      <Breadcrumb>
        {url.map((x, i) => (
          <Breadcrumb.Item key={x}>
            {x ? (
              x
            ) : (
              <Link to={'/dashboard2'}>
                <HomeOutlined />
              </Link>
            )}
          </Breadcrumb.Item>
        ))}
      </Breadcrumb>
    </div>
  );
};
